(() => {
  class DiagramFinder {
    constructor(root) {
      this.root = root;
      this.cards = [...root.querySelectorAll('[data-diagram-card]')];
      this.make = root.querySelector('[data-diagram-make]');
      this.model = root.querySelector('[data-diagram-model]');
      this.area = root.querySelector('[data-diagram-area]');
      this.count = root.querySelector('[data-diagram-count]');
      this.empty = root.querySelector('[data-diagram-empty]');
      this.populateMakes();
      this.populateModels();
      this.populateAreas();
      [this.make, this.model, this.area].forEach((field) => field?.addEventListener('input', () => this.filter()));
      root.querySelector('[data-diagram-clear]')?.addEventListener('click', () => this.clear());
    }

    populateMakes() {
      const makes = [...new Set(this.cards.map((card) => card.dataset.make).filter(Boolean))].sort();
      makes.forEach((make) => {
        const option = document.createElement('option');
        option.value = make;
        option.textContent = make.replace(/\b\w/g, (letter) => letter.toUpperCase());
        this.make.append(option);
      });
    }

    populateModels() {
      const models = [...new Set(this.cards.flatMap((card) => (card.dataset.models || '').split('||')).filter(Boolean))]
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
      models.forEach((model) => {
        const option = document.createElement('option');
        option.value = model;
        option.textContent = model.toUpperCase();
        this.model.append(option);
      });
    }

    populateAreas() {
      const areas = [...new Set(this.cards.map((card) => card.dataset.area).filter(Boolean))].sort();
      areas.forEach((area) => {
        const option = document.createElement('option');
        option.value = area;
        option.textContent = area.replace(/\b\w/g, (letter) => letter.toUpperCase());
        this.area.append(option);
      });
    }

    filter() {
      const make = this.make.value.trim().toLowerCase();
      const model = this.model.value;
      const area = this.area.value;
      let visible = 0;
      this.cards.forEach((card) => {
        const search = card.dataset.search || '';
        const models = (card.dataset.models || '').split('||');
        const matches = (!make || card.dataset.make === make) && (!model || models.includes(model)) && (!area || card.dataset.area === area);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      this.count.textContent = `${visible} ${visible === 1 ? 'diagram' : 'diagrams'}`;
      this.empty.hidden = visible !== 0;
    }

    clear() {
      this.make.value = '';
      this.model.value = '';
      this.area.value = '';
      this.filter();
      this.model.focus();
    }
  }

  document.querySelectorAll('[data-diagram-finder]').forEach((root) => {
    if (root.dataset.finderReady) return;
    root.dataset.finderReady = 'true';
    new DiagramFinder(root);
  });
})();
